import React from "react"
import classNames from "classnames"

import "./Submit.sass"

export function Submit({ children, className, isDisabled, ...rest }) {
  const submitClassName = classNames({
    Submit: true,
    [className]: !!className,
    isDisabled,
  })

  return (
    <a className={submitClassName} {...rest}>
      <span>{children}</span>
    </a>
  )
}
